.aj{max-width:100%;}